export let randomString = (m) => {
  m = m || 9
  let s = ''
  let r = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (let i = 0; i < m; i++) {
    s += r.charAt(Math.floor(Math.random() * r.length))
  }
  return s
}

export let htmlDecode = (input) => {
  var e = document.createElement('div')
  e.innerHTML = input
  // handle case of empty input
  return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue
}



// WEBPACK FOOTER //
// ./src/utils/string.js